import { Listbox, Transition } from '@headlessui/react';
import { ChevronDownIcon } from 'components/icons';
import { ReactComponent as CheckedIcon } from 'components/icons/icon-checked.svg';
import { Tooltip } from 'components/ui';
import { PAID_PLAN_TOOLTIP, subscriptionAccess } from 'config.js';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

interface SortBySelectorProps {
  values: string[] | number[];
  selected: string | number;
  setSelected: Function;
}
export const SortBySelector = ({
  values,
  selected,
  setSelected,
}: SortBySelectorProps) => {
  const { storeSubscriptionPlan } = useStoreSubscriptionPlan();

  return (
    <Tooltip
      text={PAID_PLAN_TOOLTIP}
      placement="auto"
      disabled={
        !!!(
          storeSubscriptionPlan < subscriptionAccess.listOfCustomersRowSelector
        )
      }
    >
      <div className="flex items-center justify-center">
        <div className="w-full max-w-xs mx-auto">
          <Listbox
            as="div"
            className="space-y-1 disabled:cursor-not-allowed disabled:opacity-50"
            value={selected}
            // @ts-ignore
            onChange={(e) => {
              setSelected(e);
            }}
            disabled={
              storeSubscriptionPlan <
              subscriptionAccess.listOfCustomersRowSelector
            }
          >
            {({ open }) => (
              <div className="relative -ml-2">
                <span className="inline-block max-w-lg">
                  <Listbox.Button
                    className={`cursor-default relative w-full pl-2 py-0.5 pr-10 rounded-lg text-left focus:outline-none focus:bg-segments-gray focus:bg-opacity-50 hover:bg-segments-gray hover:bg-opacity-50 transition ease-in-out duration-150 sm:text-sm sm:leading-5 font-bold ${
                      open && 'bg-segments-gray bg-opacity-50'
                    }`}
                  >
                    <span
                      className={`block truncate text-base leading-7 text-black font-normal`}
                    >
                      Sort by{' '}
                      <span className="font-bold capitalize">
                        {String(selected)
                          .replace('_', ' ')
                          .replace('clv', 'CLV')}
                      </span>
                    </span>
                    <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                      <ChevronDownIcon className="w-5 h-5" />
                    </span>
                  </Listbox.Button>
                </span>

                <Transition
                  show={open}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                  className="absolute z-50 min-w-full mt-1 bg-white shadow-lg rounded-2xl"
                >
                  <Listbox.Options
                    static
                    className="max-w-xl overflow-auto leading-6 divide-y rounded-md shadow-xs max-h-60 focus:outline-none sm:text-sm sm:leading-5 scrollbars-hidden"
                  >
                    {values?.map((item) => (
                      <Listbox.Option key={item} value={item}>
                        {({ selected, active }) => (
                          <div
                            className={`${
                              active
                                ? 'bg-segments-accent-green-3'
                                : 'text-gray-900'
                            } cursor-default select-none relative py-2.5 text-base px-8`}
                          >
                            <span
                              className={`${
                                selected ? 'font-semibold' : 'font-normal'
                              } flex space-x-3 items-center`}
                            >
                              <p className="capitalize truncate">
                                {String(item)
                                  .replace('_', ' ')
                                  .replace('clv', 'CLV')}
                              </p>
                            </span>
                            {selected && (
                              <span
                                className={`${
                                  active ? 'text-black' : 'text-segments-dark'
                                } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                              >
                                <CheckedIcon />
                              </span>
                            )}
                          </div>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            )}
          </Listbox>
        </div>
      </div>
    </Tooltip>
  );
};
